import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-stats',
  template: `
    <div class="d-flex justify-content-center">
    <div class="title p-1 border-2 border-dark rounded bg-transparent h5" style="border: 1px solid #4d4a4a;color: #464646;">
            #IC
            <span class="badge fs-5 p-2 shadow" [ngClass]="getBadgeClass('ic')">
              {{ icTotal || 0 }} 
            </span>
            | #AM
            <span class="badge fs-5 p-2 shadow" [ngClass]="getBadgeClass('am')">
              {{ amTotal || 0 }}
            </span>
            | #OE 
            <span class="badge fs-5 p-2 shadow" [ngClass]="getBadgeClass('oe')">
              {{ oeTotal || 0 }}
            </span>
            | #Total Agents
            <span class="badge fs-5 p-2 shadow" [ngClass]="getBadgeClass('total')">
               {{  icTotal + amTotal + oeTotal }}
            </span>
          </div>
    </div>
  `,
})
export class StatsComponent {
  @Input() icTotal: any;
  @Input() amTotal: any;
  @Input() oeTotal: any;


  getBadgeClass(status: string): string {
    switch (status) {
      case 'ic':
        return 'badge-approuve';
        break;
      case 'am':
        return 'badge-planifie';
        break;
      case 'oe':
        return 'badge-accepte';
        break;
      case 'total':
        return 'badge-dark';
        break;
      default:
        break;
    }
  }
}
